import { connect } from 'react-redux';

import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import ChecklistFilterButton from './ChecklistFilterButton';
import { getTaskFilters, getTaskFacets } from '../../../../selectors/checklist/checklistSelectors';

const mapStateToProps = state => ({
  taskFilters: getTaskFilters(state),
  taskFacets: getTaskFacets(state),
});

const mapDispatchToProps = dispatch => ({
  toggleFilter: filterValue => dispatch(checklistV2Actions.toggleTaskFilter(filterValue)),
  filterTaskDesktop: filterValue => dispatch(checklistV2Actions.handleToggleTaskFilter(filterValue)),
  applyFilters: () => dispatch(checklistV2Actions.handleApplyFilters()),
  clearFilters: () => dispatch(checklistV2Actions.clearFilters()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistFilterButton);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistFilterButton/index.js